module.exports = __webpack_public_path__ + "img/DSC_2848.0040ca30.jpg";